import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { APIRequestResources, CachedAPIRequest } from '../../../core';
import { handleError } from '../../../core/utils/utils';
import { HoldReason } from '../interface/time-track.entity';

@Injectable({
  providedIn: 'root'
})
export class TimeTrackService extends CachedAPIRequest {
  constructor(protected override http: HttpClient) {
    super(http, APIRequestResources.TimeTrackService);
  }

  getHoldReasonsByOperation(searchParams: any, refresh = true): Observable<{ data: HoldReason[] }> {
    return this.get<HoldReason[]>({ endpoint: 'hold-reasons-by-operation', params: searchParams }, refresh ? 'freshness' : 'performance')
      .pipe(catchError(handleError));
  }
}
